var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0"},attrs:{"src":`${_vm.url}/embed`,"allowfullscreen":"","scrolling":"no"}})
}
var staticRenderFns = []

export { render, staticRenderFns }